export default __webpack_public_path__ + "static/media/zslogo.854a0937.png";